export const FETCH_PAGES = "pages/FETCH_PAGES";
export const FETCH_PAGES_SUCCESS = "pages/FETCH_PAGES_SUCCESS";
export const FETCH_PAGES_ERROR = "pages/FETCH_PAGES_ERROR";
